/**
 * Icon-name → MUI component map used by the App sidebar for config menus
 * and subsystem sections. Exported so Designer offers exactly the same set.
 */
import type { ComponentType } from 'react'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import AssessmentIcon from '@mui/icons-material/Assessment'
import CampaignIcon from '@mui/icons-material/Campaign'
import DashboardIcon from '@mui/icons-material/Dashboard'
import EventNoteIcon from '@mui/icons-material/EventNote'
import FactoryIcon from '@mui/icons-material/Factory'
import GroupsIcon from '@mui/icons-material/Groups'
import InventoryIcon from '@mui/icons-material/Inventory2'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import PaymentsIcon from '@mui/icons-material/Payments'
import PersonSearchIcon from '@mui/icons-material/PersonSearch'
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing'
import ReceiptIcon from '@mui/icons-material/Receipt'
import TimelineIcon from '@mui/icons-material/Timeline'

export const CONFIG_MENU_ICONS: Record<string, ComponentType<{ sx?: object }>> = {
  AccountBalance: AccountBalanceIcon,
  AccountTree: AccountTreeIcon,
  Assessment: AssessmentIcon,
  Campaign: CampaignIcon,
  Dashboard: DashboardIcon,
  EventNote: EventNoteIcon,
  Factory: FactoryIcon,
  Groups: GroupsIcon,
  Inventory2: InventoryIcon,
  MenuBook: MenuBookIcon,
  Payments: PaymentsIcon,
  PersonSearch: PersonSearchIcon,
  PrecisionManufacturing: PrecisionManufacturingIcon,
  Receipt: ReceiptIcon,
  Timeline: TimelineIcon,
}

export const CONFIG_MENU_ICON_NAMES = Object.keys(CONFIG_MENU_ICONS)
